import { memo, forwardRef } from 'react'

import SvgIcon from '@mui/material/SvgIcon'

// ----------------------------------------------------------------------

const AvatarShape = forwardRef((props, ref) => {
  const { sx, ...other } = props

  return (
    <SvgIcon
      ref={ref}
      fill='none'
      viewBox='0 0 280 120' // Adjusted for new size
      xmlns='http://www.w3.org/2000/svg'
      sx={[
        () => ({
          width: 280, // Adjusted width (previously 224)
          height: 120, // Increased height (previously 96)
          color: 'background.paper'
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <path
        d='M216 46c-20-20-35-46-73.5-46h-2.25C102.5 0 87.5 26 67.5 46 52.5 64 27 69.5 0 70.5V120h280V70.5C253 69.5 227.5 64 216 46Z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </SvgIcon>
  )
})

export default memo(AvatarShape)
